import * as React from "react";
import { forwardRef } from "react";
const HdfcIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  "data-category": "payment-methods",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fill: "#ed232a",
  d: "M5 6.007652h36.985992v36.980904H5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.47365 12.480309h24.043322v24.040222H11.47365z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.644358 6.007652h3.697277v36.980904h-3.697277z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5 22.65443h36.985992v3.696612H5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#004c8f",
  d: "M17.9473 18.952965h11.096239v11.09469H17.9473z"
}));
const ForwardRef = forwardRef(HdfcIcon);
ForwardRef.category = "payment-methods";
export default ForwardRef;
export { ForwardRef as HdfcIcon };